module.exports = __webpack_public_path__ + "static/divas0-4a10309af087d15d84e8cef3017131ec.jpg";